module.exports = __webpack_public_path__ + "img/trasporto.f3062897.png";